import { Appointment } from "@onpreo/database/src/definitions/appointment";

export type BrokerAppointmentState = Appointment[];

export const initialBrokerAppointmentState = [] as BrokerAppointmentState;
